// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"982d5e7e","455":"35838bb9","829":"d70f1027"}[chunkId] + ".chunk.js";
};